iScreenWizard.factory('ErrorHandler', function ($mdDialog, Dictionary) {

	var handler = {};

	handler.hasErrors = function(response) {
		return response.data._errors && response.data._errors.length > 0;
	};

	handler.showDialog = function(response) {
		errorMessage = Dictionary.translate('app.something_went_wrong', true);
		if (response.data._errors.length > 0) {
			errorMessage = "";
			angular.forEach(response.data._errors, function(value, key) {
				errorMessage += value + '<br/>';
			});
		}
		return $mdDialog.show(
			$mdDialog.alert()
				.clickOutsideToClose(true)
				.title(Dictionary.translate('app.something_went_wrong', true))
				.htmlContent(errorMessage)
				.ariaLabel(Dictionary.translate('app.something_went_wrong', true))
				.ok(Dictionary.translate('app.okay', true))
		);
	};

	return handler;
});